<template>
  <div class="wrapper">
    <StepProgress
      class="progress"
      :active-step="activeStep"
      :total-step="totalStep"
    />
    <div class="text-wrapper">
      <h4>
        <slot name="step">
          ÜRÜN BİLGİLERİ
        </slot>
      </h4>
      <span>
        <slot name="nextStep" />
      </span>
    </div>
  </div>
</template>

<script>
import StepProgress from './StepProgress';
export default {
  name: 'Step',
  components: { StepProgress },
  props: {
    activeStep: {
      type: Number,
      default: () => 1,
    },
    totalStep: {
      type: Number,
      default: () => 4,
    },
  },
};
</script>

<style lang="scss" scoped>
  .wrapper {
    display: flex;
    align-items: center;
    border-bottom: 1px solid rgb(241, 242, 247);
    padding: 15px;
    margin: 0 -15px;
    margin-bottom: 15px;
    .progress {

    }
    .text-wrapper {
      padding: 0 15px;
      h4 {
        margin: 0;
      }
      span {
        font-size: 12px;
        color: rgb(149, 161, 181);
      }
    }
  }

</style>
